import React, { useEffect, useState } from 'react';
import { CheckCircle2, MessageSquareWarning, Clock } from 'lucide-react';
import api from '../../services/api';

const fmt = (s) => new Date(s).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const SignoffBadge = ({ employeeId, open, lwd, amount }) => {
  const [s, setS] = useState(undefined);
  const [rem, setRem] = useState(null);
  useEffect(() => {
    if (!open || !employeeId) return;
    api.get(`/api/offboarding/leave-settlement/${employeeId}/signoff`)
      .then((r) => { setS(r.data.signoff); setRem(r.data.reminders); }).catch(() => setS(null));
  }, [employeeId, open]);
  if (s === undefined) return null;
  if (!s) return (
    <p className="flex items-center gap-1.5 text-xs text-gray-500" data-testid="settlement-signoff-badge">
      <Clock className="h-3.5 w-3.5" />
      {rem?.last_shared_at
        ? `Awaiting staff confirmation · shared ${fmt(rem.last_shared_at)} · email reminders sent ${rem.reminder_count || 0}/3${rem.last_reminder_at ? ` (last ${fmt(rem.last_reminder_at)}${rem.last_reminder_status === 'failed' ? ', failed' : ''})` : ''}`
        : 'Not yet confirmed by staff — share via WhatsApp or email to collect sign-off.'}
    </p>
  );
  const ok = s.status === 'accepted';
  return (
    <div className={`rounded-lg border px-3 py-2 text-xs ${ok ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : 'border-amber-200 bg-amber-50 text-amber-800'}`} data-testid="settlement-signoff-badge">
      <p className="flex items-center gap-1.5 font-medium">
        {ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <MessageSquareWarning className="h-3.5 w-3.5" />}
        {ok ? 'Accepted by staff' : 'Query raised by staff'} on {fmt(s.responded_at)} · {s.balance_days} days · AED {Number(s.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} (LWD {s.lwd})
      </p>
      {s.reason && <p className="mt-0.5 italic">"{s.reason}"</p>}
      {lwd && (s.lwd !== lwd || Math.abs(Number(s.amount || 0) - Number(amount || 0)) > 0.01) && (
        <p className="mt-1 font-medium text-rose-700" data-testid="settlement-signoff-mismatch">
          Note: this response was for a different last working day or amount than shown below — re-share to get confirmation of the current figures.
        </p>
      )}
    </div>
  );
};
